class StreetSuggestionSerializer {
  static deSerialize(data) {
    return {
      id: `${data.calle}-${data.departamento}-${data.localidad}`,
      street: data.calle,
      department: data.departamento,
      city: data.localidad,
      cityId: data.idlocalidad,
    };
  }

  static deSerializeNewApi(data) {
    return {
      id: data.id,
      street: data.name,
    };
  }
}

export { StreetSuggestionSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/StreetSuggestionSerializer.js